Object.defineProperty(exports, "__esModule", { value: true });
exports.explainDataSharingNotificationIcon = void 0;
exports.explainDataSharingNotificationIcon = {
    isProfile: true,
    systemSvg: null,
    secondSvg: null,
};
//# sourceMappingURL=ExplainDataSharingNotificationIcon.js.map